// This is used to load money onto a user's account.  This
// can be done using cash or etransfer.  The person must enter
// the date and the way the user laoded their account.
import React from "react";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import InputLabel from "@material-ui/core/InputLabel";
import InputAdornment from "@material-ui/core/InputAdornment";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import MaterialUIPickers from "../../../../../components/userInputs/DatePicker.js";

export default function WalletLoadDetails({
  deposit,
  setDeposit,
  handleDepositChange,
}) {
  // The method of payment for the user. Either Etransfer or cash.
  const method = deposit.method;
  // The amount the user deposited.
  const amount = deposit.amount;
  // The date that the user deposited. It is stored as a YYYY-MM-DD string, so
  // parse it into a local Date to avoid the picker shifting it a day back in
  // negative UTC offsets (date-only ISO strings parse as UTC midnight).
  const [yr, mo, dy] = (deposit.date || "").split("-");
  const date =
    yr && mo && dy
      ? new Date(Number(yr), Number(mo) - 1, Number(dy))
      : deposit.date;

  return (
    <>
      <div className="Payment-Number-Removal">
        <h5>
          <u>Payment</u>
        </h5>
      </div>
      <FormLabel component="legend">Payment Method: </FormLabel>
      <RadioGroup
        aria-label="payment method"
        name="paymentMethod"
        value={method}
        onChange={(e) => handleDepositChange(e, deposit, setDeposit, true)}
      >
        <FormControlLabel value="cash" control={<Radio />} label="Cash" />
        <FormControlLabel
          value="etransfer"
          control={<Radio />}
          label="ETransfer"
        />
      </RadioGroup>

      <FormControl fullWidth sx={{ m: 1 }}>
        <InputLabel htmlFor="outlined-adornment-amount">Amount</InputLabel>
        <OutlinedInput
          required
          id="outlined-adornment-amount"
          value={amount}
          onChange={(e) => handleDepositChange(e, deposit, setDeposit)}
          startAdornment={<InputAdornment position="start">$</InputAdornment>}
          label="Amount"
          type="number"
        />
      </FormControl>

      <MaterialUIPickers
        required
        date={date}
        handleDateChange={(e) =>
          handleDepositChange(e, deposit, setDeposit, false, true)
        }
        label="Deposit Date"
      />
    </>
  );
}
